import { MOBILE_BREAKPOINT } from 'constants/Styles.constants'
import { css, Theme } from '@emotion/react'

export const messageContainer = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`
export const message = css`
  margin-top: 4rem;
  font-size: 1.5rem;
  font-weight: 600;
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    text-align: center;
    font-size: 1.25rem;
  }
`
export const header = css`
  font-size: 0.8rem;
`
export const formContainer = css`
  padding: 1.5rem 1.5rem;
`
export const confirmMessage = css`
  min-width: inherit;
  margin-bottom: 0.5rem;
`
export const backgroundStyle = (theme: Theme) => css`
  height: 100vh;
  background-color: ${theme.palette.background.paper};
`
